import { render, staticRenderFns } from "./addComment.vue?vue&type=template&id=6da09a88&scoped=true"
import script from "./addComment.vue?vue&type=script&lang=js"
export * from "./addComment.vue?vue&type=script&lang=js"
import style0 from "./addComment.vue?vue&type=style&index=0&id=6da09a88&prod&lang=css"
import style1 from "./addComment.vue?vue&type=style&index=1&id=6da09a88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da09a88",
  null
  
)

export default component.exports